import React from 'react'
import { Navigate } from 'react-router-dom';
import {useAuth} from '../../contexts/AuthContext';

// Signed in AND approved. An unapproved account is sent home, where the
// "waiting for approval" page is all it can see.
export default function PrivateRoute({ component: Component, ...rest }) {
    const {currentUser, isApproved} = useAuth();
    if (!currentUser) return <Navigate to="/login" />;
    if (!isApproved) return <Navigate to="/" />;
    return <Component {...rest} />;
}
